import Profile from './container'

export default Profile
